import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const useUi = () => {
    const ui = useSelector((state: RootState) => state.ui);

    return useMemo(() => ({ ui }), [ui]);
};
